import { Point } from '@pacem/pacem-foundation';
/** 2D vector utils. */
export class Vector {
    /**
     * Returns the unit (normalized) vector having the same direction and sense of the provided one.
     * @param v
     */
    static unit(v) {
        const clone = { x: v.x, y: v.y };
        this.normalize(clone);
        return clone;
    }
    static magSqr(v) {
        return v.x * v.x + v.y * v.y;
    }
    static mag(v) {
        return Math.sqrt(Vector.magSqr(v));
    }
    /**
     * Normalizes the provided vector in place.
     * @param v
     */
    static normalize(v) {
        const l = Vector.mag(v);
        if (l <= 0) {
            throw 'Cannot normalize a vector of length 0.';
        }
        const inv = 1 / l;
        v.x *= inv;
        v.y *= inv;
    }
    /**
     * Returns the vector joining two points.
     * @param p1 Start point
     * @param p2 End point
     */
    static from(p1, p2) {
        return Point.subtract(p1, p2);
    }
    /**
     * Returns the dot product between two vectors/points.
     * @param v1
     * @param v2
     */
    static dot(v1, v2) {
        return v1.x * v2.x + v1.y * v2.y;
    }
    /**
     * Returns the cross product between two vectors/points (magnitude along the z axis).
     * @param v1
     * @param v2
     */
    static cross(v1, v2) {
        return v1.x * v2.y - v1.y * v2.x;
    }
    /**
     * Checks if the two points are effectively the same location.
     * @param v1 The first point.
     * @param v2 The second point.
     * @returns True if the points are considered coincident within tolerance; otherwise, false.
     */
    static areClose(v1, v2) {
        return (v2.x - v1.x).isCloseTo(0)
            && (v2.y - v1.y).isCloseTo(0);
    }
}
